export const escapeRsqlValue = (value: string): string => {
    return value
        .replace(/\\/g, '\\\\') // Escape backslashes first
        .replace(/"/g, '\\"') // Then escape double quotes
        .replace(/'/g, "\\'"); // Then escape single quotes
};
